import { useOutletContext } from 'react-router-dom';
import CartPage from './CartPage';
import { useEffect, useState } from 'react';

const CartPageWrapper = () => {
  const context = useOutletContext();
  const [cartItems, setCartItems] = useState(() => {
    try {
      const storedCart = localStorage.getItem('cartItems');
      return storedCart ? JSON.parse(storedCart) : [];
    } catch {
      return [];
    }
  });

  // Sync cartItems when context or cartUpdated event fires
  useEffect(() => {
    const syncCart = () => {
      try {
        const storedCart = localStorage.getItem('cartItems');
        setCartItems(storedCart ? JSON.parse(storedCart) : []);
      } catch {
        setCartItems([]);
      }
    };

    window.addEventListener('cartUpdated', syncCart);
    window.addEventListener('storage', syncCart);
    return () => {
      window.removeEventListener('cartUpdated', syncCart);
      window.removeEventListener('storage', syncCart);
    };
  }, []);

  return <CartPage cartItems={cartItems} onUpdateCart={context?.onUpdateCart} />;
};

export default CartPageWrapper;
